export function waitingLabel(iso: string, now: number): string {
  const minutes = Math.max(0, Math.round((now - new Date(iso).getTime()) / 60_000))
  if (minutes < 60) return `${minutes} мин`
  const hours = Math.round(minutes / 60)
  if (hours < 48) return `${hours} ч`
  return `${Math.round(hours / 24)} дн`
}

export const ARCANA_READINGS_KEY = ['arcana-readings']

export type QueueFilter = 'new' | 'in_progress' | 'done' | 'rejected' | 'all'

export const FILTERS: ReadonlyArray<{ id: QueueFilter; label: string }> = [
  { id: 'all', label: 'Все' },
  { id: 'new', label: 'Ждут ответа' },
  { id: 'in_progress', label: 'В работе' },
  { id: 'done', label: 'Готовые' },
  { id: 'rejected', label: 'Отклонённые' },
]

export type SortDir = 'old' | 'new'

export function defaultSort(filter: QueueFilter): SortDir {
  return filter === 'new' || filter === 'in_progress' ? 'old' : 'new'
}

export function errorText(e: unknown): string {
  return e instanceof Error ? e.message : 'Что-то пошло не так'
}
